export type RateLimitDecision =
    | { allowed: true }
    | { allowed: false; retryAfterMs: number };

export interface SlidingWindowGuardOptions {
    maxEventsPerSecond: number;
    maxEventsPerTenSeconds: number;
    cooldownMs: number;
}

const DEFAULT_OPTIONS: SlidingWindowGuardOptions = {
    maxEventsPerSecond: 20,
    maxEventsPerTenSeconds: 120,
    cooldownMs: 30_000,
};

/**
 * Limita rajadas locais sem considerar o navegador uma fonte confiável.
 * A API continua sendo responsável por aplicar limites definitivos.
 */
export class SlidingWindowGuard {
    private accepted: number[] = [];
    private blockedUntil = 0;

    constructor(
        private readonly now: () => number = () => performance.now(),
        private readonly options: SlidingWindowGuardOptions = DEFAULT_OPTIONS,
    ) {}

    remainingMs(): number {
        return Math.max(0, this.blockedUntil - this.now());
    }

    check(): RateLimitDecision {
        const now = this.now();

        if (this.blockedUntil > now) {
            return { allowed: false, retryAfterMs: this.blockedUntil - now };
        }

        this.accepted = this.accepted.filter(time => now - time < 10_000);
        const eventsInLastSecond = this.accepted.filter(time => now - time < 1_000).length;

        if (
            eventsInLastSecond >= this.options.maxEventsPerSecond ||
            this.accepted.length >= this.options.maxEventsPerTenSeconds
        ) {
            this.accepted = [];
            this.blockedUntil = now + this.options.cooldownMs;
            return { allowed: false, retryAfterMs: this.options.cooldownMs };
        }

        this.accepted.push(now);
        return { allowed: true };
    }
}
